module.exports = __webpack_public_path__ + "static/media/halloween1.a9d266f1.webp";